import { GlobalAbortControllers } from "global/globalAbortControllers"
import { useIndexedDB } from "./useIndexedDB"

export function useBatchedUploadFromIndexedDB(dataBaseName, storeName, batchSize, metaDataStoreName) {
  const { addDataIntoStore, getAllDataFromStore, deleteSingleDataEntryFromStore, deleteIndexedDB } = useIndexedDB(
    dataBaseName,
    storeName
  )

  async function* batchGenerator(customBatchSize = batchSize) {
    let storedData = (await getAllDataFromStore(null, "processedAudio")) ?? []
    for (let i = 0; i < storedData.length; i += customBatchSize) {
      yield storedData.slice(i, i + customBatchSize)
    }
  }

  async function batchUploadAll({ batchQuery, finalUploadQuery, id, deleteOnFail }) {
    if (batchQuery) {
      let generator = batchGenerator()

      for await (const batch of generator) {
        await Promise.allSettled(
          batch.map(async (item, index) => {
            if (GlobalAbortControllers.has(item?.id)) {
              GlobalAbortControllers.get(item?.id)?.abort()
            }
            const controller = new AbortController()
            const signal = controller.signal

            GlobalAbortControllers.set(item?.id, controller)

            try {
              let response = await batchQuery(item, item?.id, signal)

              if (response?.data) {
                await deleteSingleDataEntryFromStore(item?.id, "processedAudio")
                await addDataIntoStore({ partId: item?.id, etag: response?.data?.etag }, metaDataStoreName)
              }
            } catch (error) {
              console.log("ERROR", error)
            }
          })
        )
        console.log("Finished processing batch:", batch)
      }
    }
    let allBlobData = await getAllDataFromStore(null, "processedAudio")

    if (finalUploadQuery && allBlobData?.length <= 0) {
      const getAllMetaData = await getAllDataFromStore(null, metaDataStoreName)
      try {
        let response = await finalUploadQuery({ data: getAllMetaData, id: id, fileName: `meetings/${id}` })
        if (!response?.error) {
          await deleteIndexedDB(dataBaseName)
        }
      } catch {
        if (deleteOnFail) {
          await deleteIndexedDB(dataBaseName)
        }
      } finally {
        return true
      }
    }
  }

  return { batchUploadAll }
}
